<div class="w-full">
  <p-tabs [(value)]="activeTab" (valueChange)="onTabChange($event)">
    <p-tablist>
      @for (tab of tabs; track tab.id) {
        <p-tab [value]="tab.id" style="width:{{tabWidth()}}%">
          {{ tab.label | translate }}
        </p-tab>
      }
    </p-tablist>

    <p-tabpanels>
      @for (tab of tabs; track tab.id) {
        <p-tabpanel [value]="tab.id">

          @if (tab.component) {
            <div>
              <ng-container *ngComponentOutlet="tab.component"></ng-container>
            </div>
          }

          @if (tab.template) {
            <div>
              <ng-container
                *ngTemplateOutlet="tab.template; context: { $implicit: tab }">
              </ng-container>
            </div>
          }

          @if (tab.content) {
            <div [innerHTML]="tab.content"></div>
          }

        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</div>
